import { recordPath, recordRoute } from '@/shared/registry'

/** Where the course pages live: Find Courses, then each course's. */
export const coursesPath = '/catalog/courses'
export const createCoursePath = `${coursesPath}/new`
export const courseRoute = recordRoute('catalog', 'courses')
export const editCourseRoute = `${courseRoute}/edit`

/** A course's details page. */
export function coursePath(id: string): string {
  return recordPath('catalog', 'courses', id)
}

/** A course's edit page. */
export function editCoursePath(id: string): string {
  return `${coursePath(id)}/edit`
}

/** The API's course endpoints. */
export const coursesApi = '/catalog/v1/courses'

export function courseApi(id: string): string {
  return `${coursesApi}/${encodeURIComponent(id)}`
}

/** Copies a course, for Open Template (no body) and Save As (the form as it stands). */
export function copyCourseApi(id: string): string {
  return `${courseApi(id)}/copy`
}

/** Courses' names, and nothing else of them, for anyone signed in: `?ids=` up to 100, separated by commas. */
export const courseNamesApi = '/catalog/v1/course-names'

/** A new course's defaults in an organization. */
export function courseDefaultsApi(organizationId: string): string {
  return `${coursesApi}/defaults?organizationId=${encodeURIComponent(organizationId)}`
}

/** What each course action needs; class capacities, the External ID and post-class lab hours also need their aspect. */
export const readCoursesPermission = 'catalog.courses.read'
export const writeCoursesPermission = 'catalog.courses.write'
export const deleteCoursesPermission = 'catalog.courses.delete'
export const writeCourseCapacityPermission = 'catalog.courses.capacity.write'
export const writeCourseExternalIdPermission = 'catalog.courses.external-id.write'
export const writeCoursePostClassLabsPermission = 'catalog.courses.post-class-labs.write'
/** Save a course without a content provider. */
export const contentProviderExemptPermission = 'catalog.courses.content-provider-exempt.write'
/** Choose a course's presenters, on a course the viewer may change. */
export const writeCoursePresentersPermission = 'catalog.courses.presenters.write'
/** Set a course's Microsoft Learn switch and course URL (CAT-14). */
export const writeCourseMicrosoftLearnPermission = 'catalog.courses.microsoft-learn.write'

/**
 * The slots the course pages offer other areas. On Create and Edit Course: `formSections`, more
 * sections after the form's own, and `advancedFields`, fields at the end of Advanced, each saving
 * itself. On Course Details: the page's tabs, side-menu links, header actions and panels
 * (`detailsSlots(courseDetailsSlot)`), and panels at the end of Overview and of Resources.
 */
export const courseFormSectionsSlot = 'catalog.course-form.sections'
export const courseAdvancedFieldsSlot = 'catalog.course-form.advanced'
export const courseDetailsSlot = 'catalog.course-details'
export const courseOverviewSlot = 'catalog.course-details.overview'
export const courseResourcesSlot = 'catalog.course-details.resources'
